import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import "../../styles/vendor/react-checkbox-tree.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { getCrewMembers } from "../../services/api/crewMembers";
import BasicSelect from "./fields/BasicSelect";
import { Trans } from "react-i18next";
import { getUserByBarcode } from "../../services/api/scanning";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      crewMembers: []
    };

    this._handleSearchUser = this._handleSearchUser.bind(this);
    this._handleChangeUser = this._handleChangeUser.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    setValues: PropTypes.func,
    isCreating: PropTypes.bool,
    setFieldValue: PropTypes.func,
    event: PropTypes.object,
    materials: PropTypes.array,
    status: PropTypes.object,
    values: PropTypes.object,
    setStatus: PropTypes.func
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentProps = this.props;

    if (
      currentProps.values.barcode !== nextProps.values.barcode &&
      nextProps.values.barcode
    ) {
      getUserByBarcode(this.props.event.id, nextProps.values.barcode).then(
        response => {
          this.props.setFieldValue("crewMemberId", response.crewMemberId);
          this.props.setFieldValue("registrationId", response.registrationId);
          this.setState({
            selectedUser: [
              {
                user: {
                  firstName: response.firstName,
                  lastName: response.lastName
                },
                registration: {
                  company: {
                    name: response.companyName
                  }
                }
              }
            ]
          });
        }
      );
    }

    if (nextProps.status && nextProps.status.success) {
      this.props.setStatus({ success: false });
      this.setState({
        selectedUser: []
      });
    }

    if (currentProps.isCreating && !nextProps.isCreating) {
      currentProps.resetForm();
    }
  }

  _handleSearchUser(value) {
    getCrewMembers({
      "filter[event_id]": this.props.event.id,
      "filter[name_like]": value,
      include: "user,registration,registration.company"
    }).then(response => {
      this.setState({
        crewMembers: response.data
      });
    });
  }

  _handleChangeUser(values) {
    if (values.length > 0) {
      this.props.setFieldValue("crewMemberId", values[0].id);
      this.props.setFieldValue("registrationId", values[0].registrationId);
      this.setState({
        selectedUser: values
      });
    } else {
      this.props.setFieldValue("crewMemberId", "");
      this.props.setFieldValue("registrationId", "");
      this.setState({
        selectedUser: []
      });
    }
  }

  render() {
    const props = this.props;
    const { crewMembers, selectedUser } = this.state;
    const { materials } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <div className="row">
            <div
              className="col-lg-6"
              style={{
                borderRight: "1px dashed #ebedf2"
              }}
            >
              <BasicSelect
                {...props}
                name="materialId"
                label="What material are you renting?"
                placeholder="Select Material"
                options={materials.map(material => {
                  return {
                    value: material.id,
                    title: material.name
                  };
                })}
              />

              <BasicInput {...props} name="code" type="text" label="Code" />
            </div>
            <div className="col-lg-6">
              <BasicInput
                {...props}
                name="barcode"
                type="text"
                label="Barcode"
              />

              <div className="m--align-center" style={{ height: 0 }}>
                - or -
              </div>

              <div className="form-group m-form__group">
                <label>Name</label>
                <AsyncTypeahead
                  multiple={false}
                  options={crewMembers}
                  isLoading={false}
                  placeholder={"Search ..."}
                  selected={selectedUser}
                  minLength={2}
                  labelKey={crewMember =>
                    `${crewMember.user.firstName} ${crewMember.user.lastName} (${crewMember.registration.company.name})`
                  }
                  ref={this.destinationUserIdsTA}
                  onSearch={this._handleSearchUser}
                  onChange={this._handleChangeUser}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                key="1"
                className={
                  "btn m-btn btn-primary" +
                  (props.isSubmitting
                    ? " m-btn--custom m-loader m-loader--light m-loader--left"
                    : "")
                }
                disabled={props.isSubmitting}
              >
                <Trans>Create</Trans>
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const RentalForm = withFormik({
  mapPropsToValues: props => {
    return {
      materialId: props.lastRentedMaterial ? props.lastRentedMaterial : "",
      code: "",
      crewMemberId: "",
      registrationId: "",
      barcode: ""
    };
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.materialId || values.materialId === "") {
      errors.materialId = "required";
    }

    if (!values.code || values.code === "") {
      errors.code = "required";
    }

    if (!values.crewMemberId || values.crewMemberId === "") {
      errors.crewMemberId = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm, setStatus }) => {
    props.onSubmit(values).then(() => {
      resetForm();
      setStatus({ success: true });
    });
  }
})(InnerForm);

export default RentalForm;
